<template>
    <v-card class="pa-3" height="100%">
        <apexchart
        type="pie"
        height="360"
        :options="chart.division.options"
        :series="chart.division.series"
        ></apexchart>
    </v-card>
</template>
<script>
  import { mapGetters } from "vuex";  
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts,
    },
  data: () => ({
      chart: {
        division: {
            series: [],
            options: {
                title: {
                text: "Dasher Division Overview",
                },
                noData: {
                text: "No data available",
                },
                chart: {
                type: "pie",
                toolbar: {
                    show: true,
                },
                },
                labels: [],
                colors: [
                "#888888",
                "#71974c",
                "#00a0de",
                "#f9a01a",
                "#d34626",
                "#a9343a",
                "#9C27B0",
                "#3E2723"
                ],
                legend: {
                show: true,
                position: "bottom",
                },
            },
        },
      }

    }),

    created() {
      // this.initialize();
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["division-report"]);
        this.updateCharts();
      },

      async updateCharts() {  
        this.chart.division.options = {
          labels: this.indexData.division_overview.labels,
        };  
        let fetched_data = this.indexData.division_overview.series;
        this.chart.division.series = [1].concat(Array(fetched_data.length).fill(0));
        // console.log(this.chart.projectBudget.series);

        setTimeout(() => {
          this.chart.division.series = fetched_data;
        }, 500);
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>